import { SvgIcon } from "@mui/material";

const CloseButton = ({ color }) => (
    <SvgIcon viewBox="0 0 24 24">
              <path
                d="M12 20.4C10.8969 20.4 9.80459 20.1827 8.78546 19.7606C7.76632 19.3384 6.84031 18.7197 6.0603 17.9397C5.28029 17.1597 4.66155 16.2337 4.23941 15.2145C3.81727 14.1954 3.6 13.1031 3.6 12C3.6 10.8969 3.81727 9.80459 4.23941 8.78546C4.66155 7.76632 5.28029 6.84031 6.0603 6.0603C6.84032 5.28029 7.76633 4.66155 8.78546 4.23941C9.8046 3.81727 10.8969 3.6 12 3.6C13.1031 3.6 14.1954 3.81727 15.2145 4.23941C16.2337 4.66155 17.1597 5.28029 17.9397 6.0603C18.7197 6.84032 19.3384 7.76633 19.7606 8.78546C20.1827 9.8046 20.4 10.8969 20.4 12C20.4 13.1031 20.1827 14.1954 19.7606 15.2145C19.3384 16.2337 18.7197 17.1597 17.9397 17.9397C17.1597 18.7197 16.2337 19.3384 15.2145 19.7606C14.1954 20.1827 13.1031 20.4 12 20.4L12 20.4Z"
                stroke={color}
                strokeOpacity="1"
                strokeWidth="0.5"
              ></path>
              <path
                d="M9 9L15 15"
                stroke="#000000"
                strokeWidth="1.5"
                strokeLinecap="round"
              ></path>
              <path
                d="M15 9L9 15"
                stroke="#000000"
                strokeWidth="1.5"
                strokeLinecap="round"
              ></path>
            </SvgIcon>
  );
  
  export default CloseButton;
  